import GroupFilter from "./GroupFilter";

/**
 * A group of checkboxes — multi-select. Value is an array of the checked term ids.
 */
export default class CheckboxFilter extends GroupFilter {
    get multiple() {
        return true;
    }
}
